import { useCallback, useState } from "react";

import { getExhClient, isExhClientInitialized } from "lib/extrahorizon/client";
import { ExhApiError } from "lib/extrahorizon/types";
import { parseExhError } from "lib/extrahorizon/utils";
import { PatientStatusResponse } from "types/patient";

interface UseUpdatePatientStatusResult {
  updatePatientStatus: (patientId: string) => Promise<PatientStatusResponse>;
  loading: boolean;
  error: ExhApiError | null;
}

export const useUpdatePatientStatus = (): UseUpdatePatientStatusResult => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<ExhApiError | null>(null);

  const updatePatientStatus = useCallback(async (patientId: string): Promise<PatientStatusResponse> => {
    if (!isExhClientInitialized()) {
      const err = parseExhError(new Error("ExtraHorizon client not initialized"));
      setError(err);
      throw err;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await getExhClient().tasks.api.post("patient-status", "", {
        patient_id: patientId, // eslint-disable-line camelcase
      });
      return response as PatientStatusResponse;
    } catch (err) {
      const parsed = parseExhError(err);
      setError(parsed);
      throw parsed;
    } finally {
      setLoading(false);
    }
  }, []);

  return { updatePatientStatus, loading, error };
};
